<template>
  <li :class="{ 'catalog-item--payable': payable }" class="catalog-item">
    <!-- image & payable -->
    <div class="catalog-item__image" @click="onSelect">
      <!-- image -->
      <picture>
        <source :srcset="`${link}webp`" type="image/webp" />
        <img :src="`${link}jpg`" :alt="title" type="image/jpg" />
      </picture>

      <!-- payable -->
      <div v-if="payable" class="catalog-buy">
        <p class="catalog-buy__text">Buy to unlock</p>
        <button class="catalog-buy__btn">Buy</button>
      </div>
    </div>

    <!-- title -->
    <h3 class="catalog-item__title">{{ title }}</h3>
  </li>
</template>

<script>
export default {
  name: "SliderCatalogItem",

  props: {
    title: String,
    alias: String,
    preview: String,
    payable: Boolean
  },

  computed: {
    link() {
      const { alias, preview } = this;
      return `/assets/img/items/${alias}/${preview}.`;
    }
  },

  methods: {
    onSelect() {
      this.$emit("select");
    }
  }
};
</script>
